module.exports = __webpack_public_path__ + "static/media/notViewSkus.6db097c8.svg";